import type { GridSortModel } from "@mui/x-data-grid-pro"

const sortModelSignature = (sortModel: GridSortModel): string =>
  sortModel.map(({ field, sort }) => `${field}:${sort}`).join("|")

export const isSameSortModel = (
  currentSortModel: GridSortModel,
  nextSortModel: GridSortModel
): boolean =>
  sortModelSignature(currentSortModel) === sortModelSignature(nextSortModel)

export const getSortModelSignature = (sortModel: GridSortModel): string =>
  sortModelSignature(sortModel)
